
import { BaseModule, IModuleConfig } from '@kta20-core/interfaces/base-module';
import {IAppContext} from "@kta20-core/interfaces/i-app-context";
import {INavigationManager} from "@kta20-core/interfaces/i-navigation-manager";
import {ModuleViews} from "@kta20-task-manager/views/module-views";
import {MODULE_CLASS_NAME, ViewNames} from "@kta20-task-manager/constants";
import {NavigationManager} from "@kta20-ui-base/navigation-manager";


export class TaskManagerModuleConfig implements IModuleConfig {
    name: string = MODULE_CLASS_NAME;
}

export class TaskManagerModule extends BaseModule {
    static CLASS_NAME=MODULE_CLASS_NAME;

    static async factory(appContext: IAppContext, moduleConfig: IModuleConfig): Promise<BaseModule> {

        console.log(appContext);
        console.log(moduleConfig);

        const navigationManager:INavigationManager = NavigationManager.get();

        //gets a concrete class from config since
        //there might be multiple implementations (web/mob)
        navigationManager.addViews(ModuleViews);

        //preloading this view to include it manually into the DOM
        //even without navigation
        await navigationManager.loadView(ViewNames.TASK_REPORTING_VIEW);
        await navigationManager.loadView(ViewNames.TASK_FORM_VIEW);
        await navigationManager.loadView(ViewNames.TASK_CLOSURE_FORM_VIEW);

        return new TaskManagerModule;
    };
}


